import { render } from "./recharge-rule.vue?vue&type=template&id=5876a502&scoped=true"
import script from "./recharge-rule.vue?vue&type=script&lang=js"
export * from "./recharge-rule.vue?vue&type=script&lang=js"

import "./recharge-rule.vue?vue&type=style&index=0&id=5876a502&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5876a502"]])

export default __exports__